import React from 'react';
import { Crown, Shield, Eye, Edit, ChevronDown } from 'lucide-react';
import { dk, teamColor } from './teamsTheme';

// ─── TeamAvatar ───────────────────────────────────────────────────────────────
export function TeamAvatar({ team, size = 40 }) {
  const c = teamColor(team);
  const r = Math.round(size * 0.22);
  if (team?.logo_url) {
    return <img src={team.logo_url} alt={team.name}
      style={{ width:size, height:size, borderRadius:r, flexShrink:0, objectFit:'cover' }} />;
  }
  return (
    <div style={{
      width:size, height:size, borderRadius:r, flexShrink:0,
      background:`linear-gradient(135deg, ${c} 0%, ${dk(c)} 100%)`,
      display:'flex', alignItems:'center', justifyContent:'center',
      fontSize:Math.round(size*.44), fontWeight:700, color:'#fff', userSelect:'none',
    }}>
      {(team?.name || '?').charAt(0).toUpperCase()}
    </div>
  );
}

// ─── HubRoleBadge ─────────────────────────────────────────────────────────────
export function HubRoleBadge({ role, T }) {
  if (role === 'owner') return (
    <span style={{
      display:'inline-flex', alignItems:'center', gap:4, borderRadius:99,
      border:'1px solid rgba(139,92,246,0.35)', background:'rgba(139,92,246,0.15)',
      padding:'2px 8px', fontSize:11, fontWeight:500, color:'#a78bfa',
    }}>
      <Crown size={9}/> owner
    </span>
  );
  if (role === 'admin') return (
    <span style={{
      display:'inline-flex', alignItems:'center', gap:4, borderRadius:99,
      border:`1px solid ${T.chipBorder}`, background:T.chip,
      padding:'2px 8px', fontSize:11, fontWeight:500, color:T.textSub,
    }}>
      <div style={{width:8,height:8,borderRadius:'50%',border:`1.5px solid ${T.textSub}`}}/>
      admin
    </span>
  );
  return <span style={{fontSize:11, color:T.textMuted}}>{role}</span>;
}

// ─── TableRoleBadge ───────────────────────────────────────────────────────────
export const ROLE_CFG = {
  owner:  { Icon:Crown,  bg:'rgba(139,92,246,0.15)', text:'#a78bfa', border:'rgba(139,92,246,0.3)' },
  admin:  { Icon:Shield, bg:'rgba(59,130,246,0.12)', text:'#93c5fd', border:'rgba(59,130,246,0.25)' },
  editor: { Icon:Edit,   bg:null, text:null, border:null },
  viewer: { Icon:Eye,    bg:null, text:null, border:null },
  member: { Icon:Edit,   bg:null, text:null, border:null },
};

export function TableRoleBadge({ role, canChange, onChange, T }) {
  const base = ROLE_CFG[role] || ROLE_CFG.member;
  const { Icon } = base;
  const bg     = base.bg     ?? T.chip;
  const textC  = base.text   ?? T.textSub;
  const border = base.border ?? T.chipBorder;
  const pill = (
    <span style={{
      display:'inline-flex', alignItems:'center', gap:4, borderRadius:99,
      border:`1px solid ${border}`, background:bg,
      padding: canChange ? '2px 20px 2px 8px' : '2px 8px',
      fontSize:11, fontWeight:500, color:textC, pointerEvents:'none',
    }}>
      <Icon size={9}/> {role}
    </span>
  );
  if (!canChange) return pill;
  return (
    <div style={{position:'relative', display:'inline-flex', alignItems:'center'}}>
      {pill}
      <ChevronDown size={9} style={{position:'absolute', right:6, color:textC, pointerEvents:'none'}}/>
      <select value={role} onChange={e=>onChange(e.target.value)}
        style={{position:'absolute', inset:0, opacity:0, cursor:'pointer', width:'100%'}}>
        {['admin','editor','viewer'].map(r=><option key={r} value={r}>{r}</option>)}
      </select>
    </div>
  );
}
